import gql from 'graphql-tag';

export const PASSWORD_RESET_MUTATION = gql`
  mutation passwordResetConfirm($token: String!, $newPassword: String!) {
    passwordResetConfirm(token: $token, newPassword: $newPassword) {
      success
      error
      message
    }
  }
`;
